<template>
    <div>
        <a-modal :width="700" :visible="visible" v-show="visible" @cancel="handleCancel">
            <div style="display: flex; gap: 10px">
                <div>
                    <SupsisIcon style="width: 50px; height: 50px" />
                </div>
                <div>
                    <div class="ant-modal-title">What's New</div>
                    <p>New features, bug fixes, and content you might've missed.</p>
                </div>
            </div>

            <div class="news-modal-body">
                <ItemNewsModal
                    v-for="(item, index) in newsItems"
                    :key="index"
                    :title="item.title"
                    :ticket="item.ticket"
                    :description="item.description"
                    :newsLink="item.newsLink"
                    :date="item.date"
                    :linkText="item.linkText"
                    :ribbonText="item.ribbonText"
                    :on-click="item.onClick"
                    :on-clicked="handleCancel"
                />
            </div>
            <template #footer>
                <a-button @click="handleCancel">{{ $t("message.close") }}</a-button>
            </template>
        </a-modal>
    </div>
</template>
<script>
import ItemNewsModal from "./ItemNewsModal.vue";
import SupsisIcon from "../../views/Pages/Chatbot/pages/integrations/svg/SupsisIcon.vue";
import moment from "moment";
import SYSTEM_PUBSUB from "../../utils/systemPubSub";

export default {
    name: "NewsModal",
    components: {
        ItemNewsModal,
        SupsisIcon,
    },
    data() {
        return {
            visible: false,
            appVersion: "17", // Her yeni bir duyuru eklendiğinde bu versiyonu bir arttırın.
            lastSeenVersion: null,
            newsItems: [
                // yeni bir duyuru eklemek için aşağıdaki objeyi kopyalayın ve içeriğini doldurun ve yeni eklenen objeyi en alta değil en üstüne olacak şekilde ekleyin.
                {
                    title: "🤖Chatbot Yapay Zeka ile Hızlı Senaryo Oluşturma Özelliği Eklendi 🤖",
                    ticket: "New Feature",
                    description:
                        "✅ Artık web sitenizin adresini girdiğinizde, Chatbot oluşturmak çok daha kolay. Sizin adınıza hızlıca yapay zeka senaryolarını oluşturacak bir araçla karşı karşıyasınız.  <br/>" +
                        "✅ Senaryo oluşturmadan önce, taranan verilerinizi inceleyerek gerekli düzenlemeleri yapabilirsiniz.  <br/>" +
                        "✅ Chatbot senaryonuzdaki eksik soruların cevapları, sizin yerinize yapay zeka modülü tarafından üretilsin.<br/>",
                    date: moment("2024-01-18").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                    newsLink: "Hemen Denemek İçin Tıklayın",
                    linkText: "chatbot/stories",
                },
                {
                    title: "✨Kanban Task Sistemi ✨",
                    ticket: "New Feature",
                    description:
                        "✅ Şirket içi işlerinizi ve görev yönetimini buradan takip edebilirsiniz.<br/>" +
                        "✅ Kendinize özel görev sistemi oluşturarak görev dağılımınızı yapabilirsiniz.<br/>" +
                        "✅ Buradan şirket içi işlerinizi kolayca takip edebilir ve görevlerinizi yönetebilirsiniz.<br/>" +
                        "✅ Kişiselleştirilmiş görev sistemi ile görevlerinizi düzenleyebilir ve takibinizi yapabilirsiniz.<br/>",
                    date: moment("2024-01-18").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                    newsLink: "Hemen Denemek İçin Tıklayın",
                    linkText: "tasks",
                },
                {
                    title: "🫥Chat Copilot Özelliği Eklendi 🫥",
                    ticket: "New Feature",
                    description:
                        "Müşterilerinizle iletişim kurarken, Chat Copilot sizin için en uygun yanıtı otomatik olarak seçer.  <br/>" +
                        "Chat Copilot, müşterilerinizle iletişim kurarken size yardımcı olur.  <br/>",
                    date: moment("2024-01-18").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                    newsLink: "Hemen Denemek İçin Tıklayın",
                    linkText: "integrations/openai",
                },
                {
                    title: "🎙️Chat Ekranı Sesi Yazıya Çevirme Özelliği Eklendi 🎙️",
                    ticket: "New Feature",
                    description:
                        "✅ Artık chat ekranında sesli mesajları yazıya çevirebilirsiniz.  <br/>",
                    date: moment("2024-01-18").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                    newsLink: "Hemen Denemek İçin Tıklayın",
                    linkText: "chat",
                },
                {
                    title: "🤖 Chatbot Müşteri Yazdıktan Sonra Cevaplama Özelliği Eklendi 🤖",
                    ticket: "New Feature",
                    description:
                        "✅ Artık chatbot müşteri yazdıktan sonra cevap verebilir.  <br/>" +
                        "✅ Chatbotunuzun müşteri yazdıktan sonra cevap vermesini istiyorsanız, chatbot ayarlarından bu özelliği aktif edebilirsiniz.  <br/>",
                    date: moment("2024-01-18").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                    newsLink: "Hemen Denemek İçin Tıklayın",
                    linkText: "chatbot/stories",
                },
                {
                    title: "✨ Maillerinizi Artık Supsis Üzerinden Gönderebilirsiniz ✨",
                    ticket: "New Feature",
                    description:
                        "✅ Artık panel üzerinden ChatBot aracılığıyla hızlı e-posta gönderebilirsiniz.  <br/>"+
                        "✅ Chat penceresine giderek 'mail gönder' komutunu kullanarak veya ChatBot ile doğrudan iletişim kurarak, müşterilere anında özel e-postalar oluşturabilirsiniz.  <br/>"+
                        "✅ Ayrıca, kullanıcı dostu arayüzümüzde bulunan hazır şablonları kullanarak kişiselleştirilmiş mesajlarınızı kolayca oluşturabilirsiniz.  <br/>"+
                        "✅ Müşteri ismi, sipariş detayları ve diğer kişiselleştirilmiş bilgileri ekleyerek, hızla ve etkili bir şekilde özel mesajlarınızı iletebilirsiniz.  <br/>"
                    ,
                    date: moment("2024-01-08").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                    newsLink: "Hemen Yeni Özelliği Keşfet",
                    linkText: "integrations/mail"
                },
                {
                    title: "🔐 Bug Fix & Improvements",
                    ticket: "New Feature",
                    description:
                        "✅ Yeni şifrenizi belirlemek için panel üzerinde bulunan kullanıcı güncelle formu kullanabilirsiniz.<br/>"+
                        "✅ Artık chat ekranında görsel mesajları kopyalayıp yapıştırabilirsiniz.<br/>"+
                        "✅ Chatbot iyileştirmeleri yapıldı.<br/>"+
                        "✅ Whatsapp Kanalı Kaldırıldı Whatsapp V1 ve V2 den devam edebilirsiniz.<br/>"+
                        "✅ Müştrei Sayfası Sorunlar Giderildi.<br/>"
                    ,
                    date: moment("2024-01-08").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                },
                {
                    title: "🔄 Ziyaretçi Birleştirme Özelliği Eklendi",
                    ticket: "New Feature",
                    description:
                        "✅ Artık farklı kanallardan gelen ziyaretçileri birleştirebilirsiniz.<br/>"+
                        "✅ Visitor Merge özelliği sayesinde, aynı kişiye ait farklı kanallardan gelen bilgileri bir araya getirebilir, daha etkili bir müşteri yönetimi yapabilirsiniz.<br/>"+
                        "✅ Çift kayıtları birleştirmek için ziyaretçi profiline gidin ve 'Birleştir' seçeneğini kullanın.<br/>"+
                        "✅ Müşteri deneyimini artırmak ve verimliliği maksimize etmek için bu özelliği hemen kullanmaya başlayın.<br/>"
                    ,
                    date: moment("2024-01-08").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                },
                {
                    title: "⭐️ SMS Kanalı Eklendi ⭐️",
                    ticket: "New Feature",
                    description:
                        "✅ Chat ekranından SMS gönderebilirsiniz . <br/>" +
                        "✅️ Chatbot'tan sms gönderebilirsiniz.. <br/>" +
                        "✅️ SMS ile OTP doğrulama yapabilirsiniz. <br/>",
                    date: moment("2023-12-22").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                    newsLink: "Hemen Postacell SMS Kanalını Aktif Et",
                    linkText: "integrations/sms/postacell",
                },
                {
                    title: "Bug Fix & Improvements",
                    ticket: "",
                    description:
                        "✅ Chat ekranında hatalar giderildi . <br/>" +
                        "✅️ Chat ekranında resim kopyalama özelliği eklendi.. <br/>" +
                        "✅️ Chatbot iyileştirmeleri yapıldı.. <br/>" +
                        "✅️ Chatbot dinamik filtre kıyaslama özelliği eklendi.. <br/>" +
                        "✅️ Chatbot soru validasyonları Regex ile genişletildi <br/>" +
                        "✅️ Whatsapp V1 ve V2 kanallarından gönderiken toplu mesajlar whatsapp cüzdanınıza bağlandı <br/>" +
                        "✅️ Contact List sayfasını iyileştirildi <br/>",
                    date: moment("2023-12-22").format("YYYY-MM-DD"),
                },
                {
                    title: "⭐️ Whatsapp Bakiyesi Özelliği ⭐️",
                    ticket: "New Feature",
                    description:
                        "✅ Whatsapp business ücretlerinizi artık kendi bakiyeniz ile yönetebilirsiniz . <br/>" +
                        "✅️ Toplu whatsapp mesaj gönderimleri bu bakiyeden düşecektir.. <br/>" +
                        "✅️ Düşük bakiyeniz olduğun bakiyenizi yükseltmeyi unutmayın. <br/>",
                    date: moment("2023-12-12").format("YYYY-MM-DD"),
                    ribbonText: "WA Business",
                    newsLink: "Hemen Whatsapp Bakiyesi Yükle",
                    linkText: "settings/wallet",
                },
                {
                    title: "Yeni Güncellemeler",
                    ticket: "New Feature",
                    description:
                        "✅ Fatura sayfasında gelecek ayın faturasını anlık görebilirsiniz . <br/>" +
                        "✅️ Chat ekranında görsel mesajları kopyalayıp yapıştırabilirsiniz.. <br/>",
                    date: moment("2023-12-12").format("YYYY-MM-DD"),
                },
                {
                    title: "⭐️ Mesaj Alıntılama Özelliği (Reply) ⭐️",
                    ticket: "New Feature",
                    description:
                        "⚽️ Artık ziyaretçilerinizin mesajlarını alıntılayarak cevap verebilirsiniz. <br/>" +
                        "⚽️ Alıntılanan mesajlar ziyaretçiye gönderilirken, alıntılanan mesajın altında gösterilir. <br/>" +
                        "⚽️ Alıntılanan mesajlara tıklayarak o mesaja focus olabilirsiniz. <br/>" +
                        "⚽️ Kendi mesajlarınızı alıntılayarak ziyaretçilerinize gönderebilirsiniz. <br/>" +
                        "⚽️ Herhangi bir mesaja çift tıklayarak veya sağ tık açılan menü üzerinden o mesajı alıntılayabilirsiniz. <br/>",
                    date: moment("2023-11-22").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                },
                {
                    title: "🎉 Mesajlarda Ara Özelliği 🎉",
                    ticket: "New Feature",
                    description: "🎉️ Artık sohbet ekranında mesajlar üzerinde arama yapabilirsiniz. <br/>",
                    date: moment("2023-11-22").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                },
                {
                    title: "🎉 Paket/Plan Yönetimi  Güncellendi 🎉",
                    ticket: "New Feature",
                    description:
                        "♦️ İstediğiniz hizmet için size uygun paketi seçip satın alabilirsiniz. <br/>" +
                        "♦️ Paketlerinizi ve ödeme bilgilerinizi yönetebilirsiniz. <br/>" +
                        "♦️ Paketlerinizi istediğiniz zaman yükseltebilir veya düşürebilirsiniz. <br/>" +
                        "♦️ Faturlarınız artık size PDF olarak hem eposta üzerinden ileteceğiz hemde panelden erişebileceksiniz. <br/>" +
                        "♦️ Paketlerinizi istediğiniz zaman iptal edebilirsiniz. <br/>",

                    date: moment("2023-11-22").format("YYYY-MM-DD"),
                    ribbonText: "Paket/Plan Yönetimi",
                },
                {
                    title: "🍄🍄 Diğer Güncellemeler 🍄🍄",
                    ticket: "New Feature",
                    description:
                        "🚨 WA Business Template Mesajlarınıza artık butonlar ekleyebilirsiniz. <br/>" +
                        "🚨 WA Business'den gönderdiğniz mesajlarınız anlık durumunu izleyebileceksiniz (iletildi,okundu,görüldü)  <br/>" +
                        "🚨 Arşivde kullanıcı bilgileri üzerinden yeni filtreler eklendi. <br/>" +
                        "🚨 Takım konuşması ve ticket bildirimler sorunları düzeltildi <br/>" +
                        "🚨 Whatsapp kanallarınızın durumları anasayfadan göreceğiniz şekilde ayarladık. <br/>",

                    date: moment("2023-11-22").format("YYYY-MM-DD"),
                    ribbonText: "Fix",
                },
                {
                    title: "🔥🔥 Akıllı Arama Çubuğu Yayında. 🔥🔥",
                    ticket: "New Feature",
                    description:
                        "📍 Kişilerini hızlıca arayıp profillerine ulaşabilirsiniz. <br/>" +
                        "📍 Sadece 'git' yazarak istedğiniz sayfaya hızlıca atlayabilirsiniz.  <br/>" +
                        "📍 Sadece 'yeni' yazarak yeni kayıt ekranlarına hızlıca erişebilirsiniz. <br/>" +
                        "📍 Command + K ile açıp kapatabilirsiniz. <br/>" +
                        "📍 Bunlarla sınırlı kalmayacak şekilde çok daha fazla aksiyonu sizler için ekleyeceğiz  <br/>",
                    date: moment("2023-11-08").format("YYYY-MM-DD"),
                },
                {
                    title: "🎉🎉 Whatsapp V2 Entegrasyonu Yayında. 🎉🎉",
                    ticket: "New Feature",
                    description:
                        "👉 Karekod V1'e göre daha stabil <br/>" +
                        "👉 V1'e göre daha hızlı <br/>" +
                        "👉 İstediğiniz numaraya hızlıca chat başlatabilirsiniz. <br/>" +
                        "👉 İstediğiniz kadar kanal açıp chatbota veya canlı desteğe yönlendirebilirsiniz <br/>" +
                        "👉 Toplu mesaj özelliğide beraberinde gelmektedir. Tadını çıkarın. <br/>" +
                        "👉 Kanallara erişim ayarları koyabilirsiniz <br/>",
                    date: moment("2023-11-07").format("YYYY-MM-DD"),
                    newsLink: "Hadi , Whatsapp Kanalı Aç...",
                    linkText: "integrations/whatsapp-v2",
                },
                {
                    title: "Güncellemeler ✅",
                    ticket: "Improvements",
                    description:
                        "👉 Chatbot profil fotosu ekleme özelliği <br/>" +
                        "👉 Takım konuşması iyileştirmeleri yapıldı <br/>" +
                        "👉 Katalog özelliği güncellendi <br/>" +
                        "👉 WA Business Template ve Toplu Mesaj özelliği eklendi <br/>" +
                        "👉 Yeni raporlar eklendi <br/>" +
                        "👉 Chatbot filtreleri iyileştirildi <br/>" +
                        "👉 Roller ve yetkiler iyileştirildi <br/>",
                    date: moment("2023-10-23").format("YYYY-MM-DD"),
                },
                {
                    title: "Yenilikler ✅ 🎉🎉",
                    ticket: "New Feature",
                    description:
                        "✅ Takım Konuşması Medya Paylaşımı ve bu medyaları kullanıcılara ve tarihe göre filtreleme seçeneği ekledi.  <br/>" +
                        "✅ Marka Sloganınızı güncelleyebilir ve tetikleyiciyi ekranda görüntüleyebilirsiniz.  <br/>" +
                        "✅ Gelişmiş chatbot raporları eklendi, artık chatbotunuzun her adımını detaylı bir şekilde takip edebilirsiniz.  <br/>" +
                        "✅ Multi WhatsApp kanallarımızla hangi departmanların görüntüleyebileceğini ve hangi kullanıcıların görmesine izin vermek istediğinizi belirleyebilirsiniz.  <br/>" +
                        "✅ Ticket özelliğini Ayarlar>Özellikler sayfasından açıp kapatabilirsiniz.  <br/>" +
                        "✅ Chatbot Segment ve etikete göre filtreleme özelliği eklendi",
                    newsLink: "Hadi Başlayalım...",
                    date: moment("2023-09-26").format("YYYY-MM-DD"),
                    linkText: "chat",
                },
                {
                    title: "Düzeltilen Hatalar",
                    ticket: "Bug Fix",
                    description:
                        "❗️ Kullanıcı engelleme sorunu çözüldü. Artık kullanıcı engellemek istediğinizde sorun yaşamayacaksınız.  <br/>" +
                        "❗️ Hazır içeriklerde pasif olarak seçili olan hazır içeriklerin gelme sorunu çözüldü.  <br/>" +
                        "❗️ Ticket sayfası tablo filtrelemesi düzeltildi.  <br/>" +
                        "❗️ Ticket sayfasında ticket açıldığında ticketın açıldığı yeri gösteren link düzeltildi.",
                    date: moment("2023-09-25").format("YYYY-MM-DD"),
                    newsLink: "Hadi Başlayalım...",
                    linkText: "chat",
                },
                {
                    title: "Yeni Özellik: Takım Sohbeti (Team Chat) ✅ 🎉🎉",
                    ticket: "Yeni Özellik",
                    description:
                        "Artık takım arkadaşlarınızla birebir sohbet edebilirsiniz veya departmantdaki ekip arkadaşlarınızla veya kendi belirleyeceğiniz özel gruplarla sohbet odaları oluşturabilirsiniz. Bu özellikle takımınızla iletişiminizi kolaylaştırabilir, işbirliğinizi geliştirebilir ve verimliliğinizi artırabilirsiniz. Daha fazla bilgi için destek ekibimize başvurun. İşlerinizde başarılar!",
                    newsLink: "Hadi Başlayalım...",
                    date: moment("2023-09-19").format("YYYY-MM-DD"),
                    linkText: "chat?tabIndex=6",
                },
                {
                    title: "Yeni Özellik: Multi Whatsapp Channel 🎉🎉",
                    ticket: "Yeni Özellik",
                    description:
                        "Artık birden çok Whatsapp kanalınızı tek bir hesapta yönetebilirsiniz. Bu özellikle birden fazla Whatsapp numaranızı tek bir hesapta toplayarak yönetim süreçlerinizi kolaylaştırabilir, verimliliğinizi artırabilir ve işbirliğinizi geliştirebilirsiniz. Daha fazla bilgi için destek ekibimize başvurun. İşlerinizde başarılar!",
                    newsLink: "Whatsapp Kanalı Eklemeyi Deneyimle...",
                    date: moment("2023-09-19").format("YYYY-MM-DD"),
                    linkText: "integrations/whatsapp-v1",
                },
                {
                    title: "İyileştirme: Otomatik Chat Atama Algoritmaları Eklendi ✅",
                    ticket: "Yeni Özellik",
                    description:
                        "Otomatik chat atama yönteminizi artık değiştirebilirsiniz. Çalışma stilinize uygun algoritmayı seçerek daha verimli bir ekip oluşturabilirsiniz.",
                    newsLink: "Chat Atama Algoritmasını Değiştir",
                    date: moment("2023-09-19").format("YYYY-MM-DD"),
                    linkText: "settings/auto-assign",
                },
                {
                    title: "Yeni Özellik: Team Chat",
                    ticket: "Yeni Özellik",
                    description:
                        "Supsis Team Chat  ile artık takım arkadaşlarınızla birebir sohbet edebilirsiniz veya departmantdaki ekip arkadaşlarınızla veya kendi belirleyeceğiniz özel gruplarla sohbet odaları oluşturabilirsiniz. Bu özellikle takımınızla iletişiminizi kolaylaştırabilir, işbirliğinizi geliştirebilir ve verimliliğinizi artırabilirsiniz. Daha fazla bilgi için destek ekibimize başvurun. İşlerinizde başarılar!",
                    newsLink: "Hadi Başlayalım...",
                    date: moment("2023-09-15").format("YYYY-MM-DD"),
                    linkText: "chat?tabIndex=6",
                    onClick: () => {
                        SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.OPEN_TEAM_CHAT, {});
                    },
                },
                {
                    title: "Ziyaretci Profil Sayfası Güncellendi",
                    ticket: "UI Update",
                    description:
                        "Ziyaretci Profil Sayfası Güncellendi! Artık daha modern ve etkileşimli bir arayüzle ziyaretçi bilgilerinize kolayca erişebileceksiniz.",
                    newsLink: "Lean more...",
                    date: moment("2023-09-15").format("YYYY-MM-DD"),
                    linkText: "visitors",
                },
                {
                    title: "Yeni Entegrasyon: Whatsapp Business API",
                    ticket: "New Integration",
                    description:
                        "Whatsapp Business API ile numarınızı bize taşıyarak supsis'in tüm özelliklerinde faydanabilirsiniz. Gelen trafiğie ister canlı desteğe ister chatbot'a aktarabilirsiniz. WA Business API ile müşterilerinize kampanyan mesajları atabilirsiniz.",
                    newsLink: "Şimdi ,WA Business API'yi entegre et ...",
                    date: moment("2023-08-19").format("YYYY-MM-DD"),
                    linkText: "integrations",
                },
                {
                    title: "Webhook Entegrasyonu",
                    ticket: "Webhook",
                    description:
                        "Webhook entegrasyonu, kendi uygulamalarınızı hızlıca entegre etmenin güçlü bir yöntemidir. Webhook'lar, bir olayın gerçekleştiği anı izleyen, yakalayan ve başka bir uygulamaya anında bilgi ileten mekanizmalardır. Bu sayede veri alışverişi anında ve otomatik olarak gerçekleşir, böylece süreçlerinizi hızlandırır ve verimliliği artırır.",
                    newsLink: "Webhook Dene...",
                    date: moment("2023-08-18").format("YYYY-MM-DD"),
                    linkText: "integrations",
                },
                {
                    title: "WebChat V2 Tasarımı Yayınlandı",
                    ticket: "New Theme",
                    description:
                        "Ziyaretçi V2 Tasarımı ile yepyeni bir özellik sunuyoruz! Gelişmiş ziyaretçi takibi, anlık canlı sohbet, özelleştirilmiş mesajlar ve zengin medya paylaşımıyla müşteri deneyimini zirveye taşıyoruz. Artık web sitemize gelen her ziyaretçiyle daha kişisel ve etkileşimli bir iletişim kurabilir, satışları artırabilir ve markanızın sadık takipçi kitlesini büyütebilirsiniz. Ziyaretçi V2 Tasarımı ile işletmenizi dijital dünyada ön plana çıkarın ve rekabette bir adım öne geçin. Daha fazla bilgi için destek ekibimize başvurun. İşlerinizde başarılar!",
                    newsLink: "V2 Tasarımını Dene...",
                    date: moment("2023-08-18").format("YYYY-MM-DD"),
                    linkText: "settings/theme-settings",
                },
                {
                    title: "Yeni Özellik: Özelleştirilebilir Profil Bilgileri (Visitor Contact Properties)",
                    ticket: "New Feature",
                    description:
                        "Ziyaretcilerinize özel profil bilgileri tanımlayarak onları daha iyi tanıyabilir ve daha kişisel bir iletişim kurabilirsiniz. Örneğin, ziyaretçilerinizin doğum tarihlerini öğrenerek onlara doğum günlerinde özel mesajlar gönderebilirsiniz. Bu özellikle ziyaretçilerinizin ilgisini çekerek markanızın sadık takipçi kitlesini büyütebilirsiniz. Daha fazla bilgi için destek ekibimize başvurun. İşlerinizde başarılar!",
                    newsLink: "Hadi Başlayalım...",
                    date: moment("2023-07-17").format("YYYY-MM-DD"),
                    linkText: "visitors",
                },
            ],
        };
    },
    methods: {
        handleCancel() {
            this.visible = false;
            localStorage.setItem("last-seen-version", this.appVersion);
        },
        checkIfNewFeatures() {
            const storedVersion = localStorage.getItem("last-seen-version");

            this.visible = storedVersion !== this.appVersion;
        },
    },
    created() {
        this.checkIfNewFeatures();
    },
};
</script>
<style lang="scss" scoped>
.news-modal-body {
    padding-right: 5px;
    overflow: auto;
    max-height: 60vh;
    overflow-x: hidden;
    overflow-y: auto;

    ::-webkit-scrollbar {
        width: 0px;
        display: none;
    }

    .new-item {
        padding: 10px;
        border: 1px solid #e8e8e8;
        border-radius: 3px;
        margin-bottom: 10px;

        &:last-child {
            margin-bottom: 0;
        }

        .new-item-title {
            font-weight: bold;
            font-size: 16px;

            span {
                padding: 3px 7px;
                background-color: green;
                margin-left: 5px;
                font-weight: normal;
                color: white;

                &.feature {
                    background-color: #1890ff;
                }

                &.update {
                    background-color: purple;
                }
            }
        }

        .new-item-description {
            font-size: 12px;
        }

        .new-item-date {
            font-size: 12px;
            color: #8c8c8c;
        }
    }
}

.ant-btn:hover {
    color: #faa566;
    background-color: #fff;
    border-color: #faa566;
}

.ant-btn:focus {
    color: #faa566;
    background-color: #fff;
    border-color: #faa566;
}
</style>
